export default __webpack_public_path__ + "static/media/010-burger.6bb5fe71.svg";